<template>
  <div id="termsofuse">
    <call />
    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right">
        <div class="l-header__column l-header__column--left pl-16">
          <a href="javascript:history.back();"><img src="/assets/images/icon/icon-back-arrow.svg" alt=""></a>
        </div>
        <div class="l-header__column l-header__column--mid">
          ご利用規約
        </div>
        <div class="l-header__column l-header__column--right pr-61">

        </div>
      </div>
    </header>
    <!-- main -->
    <main id="about_this_app_terms_of_use">
      <footer-app page="top" hide="false"></footer-app>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white pt-60">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                イオンタウンアプリご利用規約
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-8">
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">1．用語の定義</div>
                <div class="c-about-group__title mb-0">
                  （1）本規約で用いる用語の定義は以下のとおりです。<br />
                  「当社」：イオンタウン株式会社<br />
                  「当サービス」：当社が提供するイオンタウンアプリサービス<br />
                  「利用者」：当サービスを利用するすべてのお客さま<br />
                  「店舗」：当社ショッピングセンター内の店舗<br />
                  「商品」：店舗が当サービスに情報を掲載しまたは当サービスを介して利用者に販売する商品またはサービス
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">2．目的</div>
                <div class="c-about-group__title mb-0">
                  （1）当社は、本規約に基づき、当サービスを使用する権利を利用者に許諾し、利用者は本規約の内容に同意するものとします。 当サービスの利用を開始した場合、利用者は、本規約に同意したものと見なします。<br />
                  <br />
                  （2）利用者が未成年である場合は、親権者など法定代理人の同意（本規約への同意を含みます）を得た上で当サービスを利用してください。また、本規約に同意した時点で未成年者であった利用者が、成年に達した後に当サービスを利用した場合、未成年者であった間の利用行為を追認したものとみなします。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">3．利用者情報について</div>
                <div class="c-about-group__title mb-0">
                  （1）利用者情報の取り扱い<br />
                  ①利用者情報は、下記に定めるほか、当社の個人情報保護方針にしたがって取り扱うものとします。 <br />
                  ②当サービスをご利用いただくにあたり、性別／生年月／郵便番号／購買履歴／閲覧履歴／アプリケ―ション利用履歴／位置情報、その他これらに準ずる情報を収集させていただく場合があります。<br />
                  ③当サービスは、利用者の登録手続を行うにあたり、当社がApple Inc.等の第三者（以下、「アカウント連携サービス運営会社」といいます。）が運営するサービス（以下「アカウント連携サービス」 といいます。）に登録された利用者に関する情報を取得し、当サービスにおいて表示する場合があることを承諾するものとします。<br />
                  ④当社は、利用者情報を以下の目的で収集、利用できるものとします。<br />
                  a．利用者に対するウェブサイト、モバイルアプリケーションによる商品やサービスなどに関する情報提供のため<br />
                  b．利用者に対するウェブサイト、モバイルアプリケーションによる各種キャンペーンの当選やスタンプなど特典獲得のご案内、商品・謝礼の提供のため<br />
                  c．マーケティングや商品開発、サービス改善の統計的データとして利用するため<br />
                  d．利用者に対する商品の品質やサービスの向上を目的としたアンケート調査に付随する諸対応のため<br />
                  e．利用者からのお問い合わせ対応、その他必要に応じた利用者との連絡のため<br />
                  ⑤利用者情報が店舗に対して提供されることについて、利用者は予め同意するものとします。<br />
                  <br />
                  （2）利用者による機能の一部停止<br />
                  利用者の操作により、利用者情報の全部または一部の取得停止、変更、削除、またはサービス利用の停止ができます。<br />
                  利用者が端末の通知機能をオフにすることで、モバイルアプリケーションによるプッシュ通知を停止できます。<br />
                  <br />
                  （3）情報の訂正、退会<br />
                  利用者がサービスの利用停止を希望する場合は、端末のアプリ削除（アンインストール）を行ってください。<br />
                  なお、サービスを利用停止した場合でも、当社がすでに収集した利用者情報は消去されません。ご留意ください。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">4．サービスの利用について</div>
                <div class="c-about-group__title mb-0">
                  （1）当サービスの利用料は無料です。<br />
                  ただし、当サービスを利用する場合に必要かつ適切な機器やソフトウェア、通信手段などの用意、当サービスへの接続にかかる費用については、利用者自身の責任と費用でご用意ください。なお、利用者が未成年である場合は、親権者など法定代理人が利用者に使用を認めたものをご使用ください。<br />
                  当社は利用者のインターネットにアクセスするための準備、方法などについてはいっさい関与いたしません。<br />
                  以下の場合、当サービスの利用ができない場合があります。なお、当社は理由のいかんによらず、当サービスが利用できなくなることによるすべての損害に対していっさいの責任を負いません。<br />
                  a．サーバ、システム等に故障が生じた場合及び定期・不定期のメンテナンスのために、システムの全部または一部を休止する場合<br />
                  b．利用者の通信機器並びに店頭の読み取り機器及びこれらに付随する機器等の破損または電磁的影響、停電その他の事由による利用不能の場合<br />
                  c．火災、停電、天災などの不可抗力により、提供が困難な場合<br />
                  d．第一種電気通信事業者の任務が提供されない場合<br />
                  e．その他やむを得ない事由のある場合<br />
                  <br />
                  （2）外部ソーシャルサービス（X、Facebook等）への投稿について<br />
                  掲示板、Xなどのソーシャルサービスを利用したコメントや写真の投稿は投稿された利用者自身の責任となります。<br />
                  <br />
                  （3）他のサービスへのリンクの扱いについて<br />
                  当サービスにおいて、第三者が提供している外部サービス（アカウント連携サービスも含みます）等へのリンクを提供している場合があります。当サービスを経由して第三者が提供する外部サービスを利用する場合、ユーザーは、外部サービス運営者が定めた利用規約・利用条件に従うものとします。<br />
                  外部サービスに対する責任は、これを提供する事業者が負います。当社は、外部サービスによるソフトウェア、広告、商品、サービスなどに起因または関連して生じたいっさいの損害（直接・間接を問いません）を賠償する責任を負いません。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">5．知的財産権について</div>
                <div class="c-about-group__title mb-0">
                  （1）当サービスのすべてのコンテンツ（著作物、肖像、キャラクター、その他のいっさいの情報）は、当社もしくは店舗、またはその委託先等が著作権等の知的財産権、使用権、その他の権利を有しています。<br />
                  著作権法で認められている範囲を超えての使用はお控え下さい。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">6．禁止事項</div>
                <div class="c-about-group__title mb-0">
                  当サービスのご利用にあたり、利用者は以下の行為を行わないものとします。<br />
                  違反した場合には、当サービスの利用を予告なくお断りする場合があります。<br />
                  a．当社、その他あらゆる人物や組織を装ったり、またそれらと提携関係にあると偽ったりそれらを他者に誤解させるように伝える行為<br />
                  b．特許権、実用新案権、商標権、意匠権、著作権、著作隣接権、肖像権、トレードシークレット、プライバシー、その他他者の権利、財産を侵害する行為、または侵害するおそれのある行為。<br />
                  c．当サービスで提供される情報、著作物を利用者の個人的な利用目的以外で、複製・複写・改変・転載し他者に利用させたり、ネットワークの内外を問わず公衆に再提供したり、他者の権利を侵害する行為<br />
                  d．他者になりすまして当サービスを利用、もしくは他者になりすまして対応機器へアクセスする行為<br />
                  e．機器内に記録されたクーポン等の情報を改ざん、消去する行為<br />
                  f．法律、法令、条例または公序良俗に違反、または違反するおそれのある行為<br />
                  g．当サービスの運営を妨げるまたは妨げるおそれのあるような行為<br />
                  h．前各号に定める行為を助長する行為。<br />
                  i．その他、当社が不適切と判断する行為。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">7．サービスの提供の変更・停止・中断・終了について</div>
                <div class="c-about-group__title mb-0">
                  当サービスのすべてまたは一部を、利用者に事前に通告することなく変更・停止・中断・終了することができるものとします。<br />
                  なお、当サービスの変更・停止・中断・終了等によって生じた損害について、当社はいっさいの責任を負いません。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">8．免責事項</div>
                <div class="c-about-group__title mb-0">
                （1）当サービスは、細心の注意をはらって情報の掲載を行なっていますが、当社は、完全性、正確性、有用性等、あるいは接続環境等に関して保証するものではありません。また、商品に関する情報は店舗が指定するものであり、当社はその完全性、正確性、有用性等について関知しません。<br />
                （2）当社は、当サービスに起因して利用者に生じたあらゆる損害についていっさいの責任を負いません。ただし、当サービスに関する当社と利用者との間の契約（本規約を含みます）が消費者契約法に定める消費者契約となる場合、この免責規定は適用しません。<br />
                （3）上記（2）ただし書に定める場合であっても、当社は、当社の過失（重過失を除きます）による債務不履行または不法行為により利用者に生じた損害のうち特別な事情から生じた損害（当社または利用者が損害発生につき予見し、または予見し得た場合を含みます）についていっさいの責任を負いません。<br />
                （4）当社では利用者が当サービスに関する内容を外部ソーシャルサービス（X、Facebook等）へ書き込んだ情報、内容について、いっさいの責任を負わないものとし、当該情報の消去を含むその管理について責任を持ちません。<br />
                書き込まれた情報によって引き起こされた問題はすべて当事者間で解決することとします。<br />
                （5）第三者による当サービスの妨害、情報改変等によってサービスが中断・遅延・あるいは誤送信等の欠陥が生じた場合、利用者あるいは第三者が被った被害については、いっさいの責任を負いません。<br />
                （6）利用者の当サービスによる店舗との取引は、全て利用者と店舗との間で行っていただくものです。したがって、商品の品質や数量等、商品に関するトラブルについては、当社はいっさいの責任を負わず、利用者と店舗との間で解決していただくことになります。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">9．利用規約の変更</div>
                <div class="c-about-group__title mb-0">
                  当社が本規約を変更する場合、当社は当サービスにて本規約を変更する旨および本規約の内容並びにその効力発生時期を告知します。当社が利用者に変更後の本規約の内容を告知し、本規約の変更の効力発生時期を経過した後に利用者が当サービスを利用した場合、利用者は、変更後の本規約に同意したこととなります。利用者が、変更後の本規約に同意しない場合、変更後に当サービスを利用することはできません。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">10．本規約の有効性</div>
                <div class="c-about-group__title mb-0">
                  (1) 本規約の各条項の全部又は一部が法令に基づいて無効と判断された場合であっても、当該条項の無効と判断された部分以外の部分及び本規約のその他の規定は、有効とします。<br />
                  (2) 本規約の各条項の一部が、ある利用者との関係で無効とされ、又は取り消された場合であっても、その他の利用者との関係においては、本規約は有効とします。
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list">11．準拠法および管轄</div>
                <div class="c-about-group__title mb-0">
                  本規約は日本法に準拠し、本規約または当サービスに関して生じるいっさいの紛争については東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </div>
              </div>
              <div class="c-release-day pb-24">
                付則<br />
                2020年11月1日制定<br />
                2025年9月1日改定
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import Vue from "vue";
export default Vue.extend({
  name: 'Termsofuse',
  components: {
    'footer-app': Footer
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  }
})
</script>